import { render, staticRenderFns } from "./LegalPublicity.vue?vue&type=template&id=5a5ed6ce&scoped=true&"
import script from "./LegalPublicity.vue?vue&type=script&lang=js&"
export * from "./LegalPublicity.vue?vue&type=script&lang=js&"
import style0 from "./LegalPublicity.vue?vue&type=style&index=0&id=5a5ed6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ed6ce",
  null
  
)

export default component.exports